import InviteHelpHeader from "@/components/InviteHelpHeader";
import { PersistContext } from "@/data/PersistProvider";
import { LanguageContext } from "@/data/LanguageProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { SendCMD } from "@/utils/HTTPRequest";
import { FormatNumberToKMB } from "@/utils/JSTool";
import { useContext, useEffect, useState } from "react";
import { FunctionalConfig } from "@/config";
import style from "./style.less";
import Games from "@/config/Games";

const Rule = ({ info }) => {
  const { getPersist } = useContext(PersistContext);
  const { getLanguage, langText, langImg } = useContext(LanguageContext);
  const [infoUpdateHour, setInfoUpdateHour] = useState("");
  const [levelConfig, setLevelConfig] = useState({});
  const [gameBetRatioConfig, setGameBetRatioConfig] = useState({});

  const history = useEnhancedHistory();
  useEffect(() => {
    if (!getPersist("dataLoaded")) {
      return;
    }
    if (!getPersist("user_info")) {
      return;
    }
    getInviteInfo();
  }, [getPersist("dataLoaded"), getPersist("user_info")]);

  const getInviteInfo = () => {
    SendCMD("getInviteInfo", {
      token: getPersist("user_info").token,
    }).then((res) => {
      if (!res.status) {
        console.log(res.errdesc);
      } else {
        let info = res.info;
        info.rid = res.player_info.rid;
        info.money = res.player_info.money.coin;
        console.log("getInviteInfo", info);
        setLevelConfig(info.config);
        setInfoUpdateHour(info.UpdateHour)
        info.game_bet_ratio_cfg && setGameBetRatioConfig(info.game_bet_ratio_cfg)
        console.log("levelConfig", levelConfig)
        console.log("gameBetRatioConfig", gameBetRatioConfig)
      }
    });
  };

  useEffect(() => {
    console.log("load Rule");
  }, []);

  let VIPLevels = [];
  for (let i = 0; i < levelConfig.length; i++) {
    let levelInfo = {
      level: langText("promotion_vip", {param1:i + 1}),
      commission: levelConfig[i][1],
      directInvitation: levelConfig[i][2],
      indirectInvitation: levelConfig[i][3]
    };
    if (levelConfig[i + 1]) {
      levelInfo.turnover = `${FormatNumberToKMB(levelConfig[i][0] / 100, ["K"])} - ${FormatNumberToKMB(
        levelConfig[i + 1][0] / 100,
        ["K"]
      )}`;
    } else {
      levelInfo.turnover = `> ${FormatNumberToKMB(levelConfig[i][0] / 100, ["K"])}`;
    }
    VIPLevels.push(levelInfo);
  }

  let gameBetRatios = [];
  gameBetRatios.push({
    name: "Slots",
    betAmount: 1,
    cashFlow: 1,
  });
  Object.keys(gameBetRatioConfig).forEach(key => {
    let gamesName = ""
    for (let i = 0; i < Games.games.length; i++) {
      if (Games.games[i].id == key) {
        gamesName = Games.games[i].name;
        break;
      }
    }
    let gameBetRatioInfo = {
      name: gamesName,
      betAmount: gameBetRatioConfig[key],
      cashFlow: 1,
    }
    gameBetRatios.push(gameBetRatioInfo)
  });

  return (
    <div class={style.fill}>
      <div class={style.content}>
        <div class={style.tab_wraper}>
          <InviteHelpHeader />
          <div style={{ minHeight: "calc(100vh - 14rem)", marginTop: "1rem" }}>
            <div class={style.tab_props_title}> Promotion Rules </div>
            <div class={style.card}>
              <div class={style.rule_card}>
                <div
                  style={{
                    fontSize: "0.93rem",
                    fontWeight: "bold",
                    marginTop: ".5rem",
                    paddingLeft: "1rem",
                    paddingRight: "1rem",
                  }}
                >
                  {langText("promotion_help_tips_1")}
                </div>
                <div style={{ fontSize: ".5rem", marginTop: ".3rem", fontWeight: 700 }}>
                  {langText("promotion_help_tips_2")}
                </div>
                <div class={style.rule_card_img}>
                  <img src={langImg("rule_member_calc")} />
                </div>
              </div>
              <div class={style.rule_detail}>
                <div class={style.rule_item}>
                  <div class={style.rule_index}>1</div>
                  <div class={style.rule_content}>
                    <div class={style.rule_title}>{langText("promotion_help_desc_1")}</div>
                    <div class={style.rule_description}>
                      {langText("promotion_help_desc_2")}
                    </div>
                  </div>
                </div>
                <div class={style.rule_item}>
                  <div class={style.rule_index}>2</div>
                  <div class={style.rule_content}>
                    <div class={style.rule_title}>{langText("promotion_help_desc_3")}</div>
                    <div class={style.rule_description}>
                      {langText("promotion_help_desc_4")}
                    </div>
                  </div>
                </div>
                <div class={style.rule_item}>
                  <div class={style.rule_index}>3</div>
                  <div class={style.rule_content}>
                    <div class={style.rule_title}>{langText("promotion_help_desc_5")}</div>
                    <div class={style.rule_description}>
                      {langText("promotion_help_desc_6_1")}
                      <br />
                      <span>{langText("promotion_help_desc_6_2")}</span>
                    </div>
                  </div>
                </div>
                <div class={style.rule_item}>
                  <div class={style.rule_index}>4</div>
                  <div class={style.rule_content}>
                    <div class={style.rule_title}>{langText("promotion_help_desc_7")}</div>
                    <div class={style.rule_description}>
                      {langText("promotion_help_desc_8", {param1:infoUpdateHour, param2:infoUpdateHour, param3:infoUpdateHour})}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                color: "#fff",
                fontSize: ".9rem",
                fontWeight: 700,
                textDecorationLine: "underline",
                textDecorationColor: "#5d7876",
                textAlign: "center",
                margin: ".6rem 0",
              }}
            >
              {langText("promotion_help_title_1")}
            </div>
            <div class={style.rule_level_table} style={{ marginBottom: "2rem", fontWeight: 700 }}>
              <table>
                <thead>
                  <tr>
                    <td style={getLanguage() == "bem" && {fontSize:"0.7rem"}}>{langText("promotion_help_title_2")}</td>
                    <td  style={getLanguage() == "bem" && {fontSize:"0.7rem"} || {width: "8rem"}}>{langText("promotion_help_title_3")}</td>
                    {FunctionalConfig.newPromotion ? (
                      <>
                        <td style={getLanguage() == "bem" && {fontSize:"0.7rem"}}>{langText("promotion_help_title_5")}</td>
                        <td style={getLanguage() == "bem" && {fontSize:"0.7rem"}}>{langText("promotion_help_title_6")}</td>
                      </>
                    ) : (
                      <>
                        <td style={getLanguage() == "bem" && {fontSize:"0.7rem"}}>{langText("promotion_help_title_4")}</td>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {VIPLevels.map((item) => {
                    return (
                      <tr key={item.level}>
                        <td>{item.level}</td>
                        <td>{item.turnover}</td>
                        {FunctionalConfig.newPromotion ? (
                          <>
                            <td>{Math.round(item.directInvitation * 10000) / 100 + "%"}</td>
                            <td>{Math.round(item.indirectInvitation * 10000) / 100 + "%"}</td>
                          </>
                        ) : (
                          <>
                            <td>{item.commission}</td>
                          </>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
  
            {FunctionalConfig.newPromotion ? (
              <>
                <div
                  style={{
                    color: "#fff",
                    fontSize: ".9rem",
                    fontWeight: 700,
                    textDecorationLine: "underline",
                    textDecorationColor: "#5d7876",
                    textAlign: "center",
                    marginTop: "-1.5rem",
                    marginBottom: "0.6rem",
                  }}
                >
                  {langText("promotion_help_title_7")}
                </div>
                <div class={style.rule_level_table} style={{ marginBottom: "2rem", fontWeight: 700 }}>
                  <table>
                    <thead>
                      <tr>
                        <td>{langText("promotion_help_title_8")}</td>
                        <td>{langText("promotion_help_title_9")}</td>
                        <td>{langText("promotion_help_title_10")}</td>
                      </tr>
                    </thead>
                    <tbody>
                      {gameBetRatios.map((item) => {
                        return (
                          <tr key={item.name}>
                            <td>{item.name}</td>
                            <td>{item.betAmount}</td>
                            <td>{item.cashFlow}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rule;
